/** Production IDs managed in GTM-TZBTJ37. Cookie disclosures still name these services. */
export const TRACKING = {
  gtmId: 'GTM-TZBTJ37',
  gaMeasurementId: 'G-GL6TBW0ZJQ',
  googleAdsId: 'AW-864888305',
  metaPixelId: '1777850496722055',
} as const

export const AGTM_SCRIPT_ID = 'neonwood-agtm'
export const AGTM_SCRIPT_SRC = '/neonwood_agtm.js'
